import script from "./ContactExpert.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactExpert.vue?vue&type=script&setup=true&lang=js"

import "./ContactExpert.vue?vue&type=style&index=0&id=30662934&lang=scss&scoped=true"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30662934"]])

export default __exports__